import { Field } from "react-final-form";
import { formatters } from "common/FormUtils";
import TextField from "./TextField";

export default function WholeNumberField({ input, ...rest }) {
    return (
        <Field {...input} {...rest} format={formatters.formatInt} formatOnBlur type="number" component={TextField} />
    );
}
